export default "__VITE_ASSET__69738885__"